const statuses = {
  paid: ['Payé', 'paid'], initiated: ['Initié', 'neutral'], pending: ['En attente', 'warning'],
  processing: ['En cours', 'neutral'], failed: ['Échoué', 'failed'], expired: ['Expiré', 'warning'],
  unpaid: ['Non payé', 'warning'], cancelled: ['Annulé', 'neutral'], canceled: ['Annulé', 'neutral'],
  refunded: ['Remboursé', 'neutral'],
};

export const PaymentStatus = ({ status, testId }) => {
  const [label, tone] = statuses[status] || [status || 'Inconnu', 'neutral'];
  return <span data-testid={testId} className={`admin-status admin-status-${tone}`}>{label}</span>;
};